import { toCapitalizeFirstLetterOfEachWord } from "../../../../consumingApi/services/helper";

const normalizeEtapa = (etapa) =>
    (etapa || "")
        .toString()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toUpperCase();

// Etapa TRANSFERENCIA = pacote coletado e levado ao polo; para quem consulta, "Coleta no polo" deixa isso claro.
export const getEtapaLabel = (etapa) => {
    if (normalizeEtapa(etapa) === "TRANSFERENCIA") return "Coleta no polo";
    return toCapitalizeFirstLetterOfEachWord(etapa);
};

export const getOperationLabel = (etapa) => {
    const normalized = normalizeEtapa(etapa);
    if (normalized === "COLETA") return "Coleta";
    if (normalized === "ENTREGA") return "Entrega";
    if (normalized === "DEVOLUCAO") return "Devolução";
    if (normalized === "TRANSFERENCIA") return "Coleta no polo";
    return "Local da operação";
};
